// extracted by mini-css-extract-plugin
module.exports = {"ForgetPassword":"ForgetPassword_ForgetPassword__pY1Ei","actions":"ForgetPassword_actions__23B8h"};